import { screeningPublicationIdentity } from './stockExplorerPublication.js';

export const BOT_STOCK_LIMIT = 100;
export const STOCK_FOCUS_PREVIEW_LIMIT = 8;

const normalizeSymbol = (value) => String(value || '').trim().toUpperCase();

export const stockFocusCandidatePreview = (stocks, limit = STOCK_FOCUS_PREVIEW_LIMIT) => {
  const seen = new Set();
  return (Array.isArray(stocks) ? stocks : []).reduce((items, stock) => {
    const symbol = normalizeSymbol(stock?.symbol);
    if (!symbol || seen.has(symbol) || items.length >= limit) return items;
    seen.add(symbol);
    items.push({
      symbol,
      companyName: String(stock?.company_name || '').trim() || symbol,
    });
    return items;
  }, []);
};

export const stockFocusSelectionLineage = (generation, profileId) => {
  const publication = screeningPublicationIdentity(generation);
  const normalizedProfile = String(profileId || '').trim();
  return publication && normalizedProfile
    ? { ...publication, profileId: normalizedProfile }
    : null;
};

export const sameStockFocusLineage = (left, right) => Boolean(
  left
  && right
  && left.profileId === right.profileId
  && left.generationId === right.generationId
  && left.generationHash === right.generationHash
  && left.profileSchemaVersion === right.profileSchemaVersion
  && left.profileBundleHash === right.profileBundleHash
);

export const pickAnotherLabel = (requestedCount, keptCount, finalCount) => {
  const changeCount = Math.max(
    Math.min(Number(requestedCount) || 0, Number(finalCount) || 0)
      - (Number(keptCount) || 0),
    0,
  );
  return changeCount > 0 ? `Pick another ${changeCount}` : null;
};

export const toggleStockFocusCandidate = ({
  symbols,
  symbol,
  currentLineage,
  candidateLineage,
  maximum = BOT_STOCK_LIMIT,
}) => {
  const normalized = [...new Set((Array.isArray(symbols) ? symbols : [])
    .map(normalizeSymbol)
    .filter(Boolean))];
  const candidate = normalizeSymbol(symbol);
  if (!candidate) return { symbols: normalized, lineage: currentLineage, limitReached: false };

  if (normalized.includes(candidate)) {
    return {
      symbols: normalized.filter((item) => item !== candidate),
      lineage: sameStockFocusLineage(currentLineage, candidateLineage)
        ? candidateLineage
        : null,
      limitReached: false,
    };
  }
  if (normalized.length >= maximum) {
    return { symbols: normalized, lineage: currentLineage, limitReached: true };
  }

  return {
    symbols: [...normalized, candidate],
    // A mixed manual/older-publication list must never be relabelled as if every
    // stock came from the current publication. The server still validates it.
    lineage: normalized.length === 0 || sameStockFocusLineage(currentLineage, candidateLineage)
      ? candidateLineage
      : null,
    limitReached: false,
  };
};

export const factoryStrategyThresholds = (strategy) => ({
  stopLoss: strategy?.presentation?.stop_loss || 'Not recorded',
  takeProfit: strategy?.presentation?.take_profit || 'Not recorded',
  risk: strategy?.presentation?.risk || strategy?.presentation?.main_risk || 'Review this strategy’s risk details.',
});
